import { useState } from "react"
import { CreateSession, DeleteSession, EditSession, SessionList } from "./Routes"
import PropTypes from "prop-types"

const SessionRouter = ({ backButton, event }) => {
  const [currentSession, setCurrentSession] = useState(null)
  const [view, setView] = useState("SESSION_LIST")
  
  const handleCancel = () => {
    setCurrentSession(null)
    setView("SESSION_LIST")
  }

  const handleCreateSession = () => {
    setCurrentSession(null)
    setView("CREATE_SESSION")
  }

  const handleDeleteSession = (session) => {
    setCurrentSession(session)
    setView("DELETE_SESSION")
  }

  const handleEditSession = (session) => {
    setCurrentSession(session)
    setView("EDIT_SESSION")
  }
  

  return (
    <div>
      {view === "SESSION_LIST" && (
        <SessionList 
          backButton={backButton}
          event={event}
          handleCreateSession={() => handleCreateSession()}
          handleDeleteSession={(session) => handleDeleteSession(session)} 
          handleEditSession={(session) => handleEditSession(session)} 
          sessions={event.sessions} 
        />
      )}

      {view === "CREATE_SESSION" && <CreateSession event={event} handleCancel={() => handleCancel()} />}
      {view === "DELETE_SESSION" && <DeleteSession session={currentSession} event={event} handleCancel={() => handleCancel()} />}
      {view === "EDIT_SESSION" && <EditSession session={currentSession} event={event} handleCancel={() => handleCancel()} />}
    </div>
  )
}

SessionRouter.propTypes = {
  event: PropTypes.object.isRequired
}

export default SessionRouter